import PropTypes from 'prop-types';
import React from 'react';

import { avatarColor, initial } from '../utils';

const NameCell = ({ row }) => (
  <div className="ab-name">
    {row.image_thumb_url ? (
      <img className="ab-avatar" src={row.image_thumb_url} alt="" />
    ) : (
      <span className="ab-avatar" style={{ background: avatarColor(row.name) }}>{initial(row.name)}</span>
    )}
    <span className="ab-name__text">
      <a href={row.path} className="ab-name__link">{row.name}</a>
      <span className="ab-name__sub">{[row.genre, row.agency].filter(Boolean).join(' · ') || '—'}</span>
    </span>
  </div>
);
NameCell.propTypes = { row: PropTypes.object.isRequired };

export default NameCell;
